import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import React, { Fragment } from 'react';
import ScrollSpy from '../../../layouts/scrollspy';
import moment from 'moment-timezone';
import ListingBadge, { BADGE_MODE } from './base';
import { isREO, getProductType } from './utils';
export default class SubjectToRedemptionBadge extends ListingBadge {
    static title = 'Subject To Redemption';
    static titleIcon = 'exclamation-triangle';
    static textIcon = 'times';
    static contentPositive = false;
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            getProductType(listing) === 'REDEMPTION' &&
            isREO(listing));
    }
    get content() {
        const redemptionDate = _.get(this.props.listing, 'listing_configuration.redemption_expiration_date', '');
        const date = moment.tz(redemptionDate, 'YYYY-MM-DD', 'America/Los_Angeles');
        const contextSuffix = date.isValid()
            ? ` until ${date.format('MMM DD, YYYY')}`
            : '.';
        return (_jsxs(_Fragment, { children: ["Per state laws, there is a period when certain parties have an opportunity to \"redeem\" a foreclosed property", contextSuffix, _jsx(ScrollSpy, { selector: '#faqs', children: ({ _active, scrollTo }) => _jsx("a", { onClick: scrollTo, children: " Learn More" }) })] }));
    }
}
//# sourceMappingURL=redemption.js.map